import { render, staticRenderFns } from "./TextJoinItemSelector.vue?vue&type=template&id=46dc2176&"
import script from "./TextJoinItemSelector.vue?vue&type=script&lang=ts&"
export * from "./TextJoinItemSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports